import React, { Component } from 'react';
import {browserHistory} from 'react-router';

require('styles/Result.scss');
class ResultComponent extends Component {
  constructor(props) {
    super(props);
    this.goBack = this.goBack.bind(this); // 打开选择列表
  }
  goBack(){
    let {action} = this.props.params;
    if(action === 'pay'){
      browserHistory.goBack();
    }else if(action === 'submit'){
      browserHistory.push('/');
    }
  }
  render(){
    let {action} = this.props.params;
    return (
      <div className="result-component">
        <div className="success">{action==='pay'?'获取成功':'提交成功'}</div>
        <div className="erweima">
          <img className="img" src="https://mp.weixin.qq.com/cgi-bin/showqrcode?ticket=gQGR8DwAAAAAAAAAAS5odHRwOi8vd2VpeGluLnFxLmNvbS9xLzAyQnkxc0EyUXdiSmUxMDAwMDAwM3IAAgRDDk1ZAwQAAAAA"></img>
        </div>
        <div className="more-info">
          <div>关注微信公众号: xiaodiqiuxp</div>
          <div className="wechat">获取实时动态推送提醒</div>
        </div>
        <div className="bottom-button columns" onClick={this.goBack.bind(this)}>确认</div>
      </div>
    );
  }
}

export default ResultComponent;



// WEBPACK FOOTER //
// ./src/components/ResultComponent.js